<div class="replay-header border-down" *ngIf="currentItem">
    <h1 class="title interview-title">{{interview_title}}</h1>
    <ng-content select=".attempts-select-div"></ng-content>
    <div class="text-right replay-header-menu">
        <ng-content select=".menu-button"></ng-content>
        <button class="btn btn_link btn_icn icn-close icon-size-lg no-margin flex-shrink-0" (click)="globalService.backToInterviewList()" [attr.aria-label]="'interviews.Close' | translate"></button>
    </div>
</div>
<div class="interview-column">
    <div class="interview-container text-left">
        <div class="recording-actions">
            <button class="btn btn_link icn icn-chevron_left" (click)="loadQuestion(currentIndex - 1);" aria-label="Previous Question"></button>
            <h2 class="title">
                {{'interviews.Question' | translate}}
                {{'interviews.Current of Total' | translate: {current_row: currentIndex + 1, total_rows: questionTotal} }}:
                {{ currentItem?.question_text }}
            </h2>
            <button class="btn btn_link icn icn-chevron_right" (click)="loadQuestion(currentIndex + 1);" aria-label="Next Question"></button>
        </div>
        <div class="question-response-selector">
            <button [disabled]="answers" (click)="onQuestionVideoSelected()" [ngClass]="{'selected-video': !responseVideoSelected}" class="btn btn_secondary question-btn">
                {{'interviews.Question' | translate}}
            </button>
            <button (click)="onResponseVideoSelected()" [ngClass]="{'selected-video': responseVideoSelected}" class="btn btn_secondary response-btn">
                {{'interviews.Your Response' | translate}}
            </button>
        </div>
        <div class="video-container">
            <div *ngIf="!answers" class="interview-video question-video">
                <vg-player (onPlayerReady)="onPlayerReady($event)">
                    <div *ngIf="!playing" class="video-overlay"></div>
                    <video [autoplay]='autoplay' [vgMedia]="media" #media
                           id="questionVideo"
                           preload="auto" controls="true">
                        <source [src]="currentItem?.question_file" type="video/mp4">
                    </video>
                </vg-player>
            </div>
            <div class="interview-video response-video">
                <vg-player (onPlayerReady)="onPlaybackReady($event)">
                    <div *ngIf="playing && !answers" class="video-overlay"></div>
                    <video [autoplay]='autoplay && answers' [vgMedia]="playback" #playback id="responseVideo"
                           preload="auto" controls="true">
                        <source [src]="currentItem?.answer_file" type="video/mp4">
                    </video>
                </vg-player>
            </div>
        </div>
        <div class="recording-actions border-down">
            <div class="replay-actions" *ngIf="!_dataService.practice">
                <toggle-button [checked]="autoplay" label="interviews.Autoplay" (change)="updateResponseState('autoplay')"></toggle-button>
                <toggle-button [checked]="answers" label="interviews.Only Answers" (change)="updateResponseState('answers')"></toggle-button>
            </div>
            <div class="replay-actions" *ngIf="_dataService.practice">
                <button [routerLink]="['../practice-complete']" class="btn btn_primary"> {{'interviews.Stop Playback' | translate}}</button>
            </div>
        </div>
        <div class="mt-2">
            <ng-content select=".feedback-form"></ng-content>
            <ng-content select=".overall-feedback"></ng-content>
            <ng-content select=".feedback-section"></ng-content>
        </div>
    </div>
</div>
